import { StyleSheet } from 'aphrodite';
import { aceGray, charmGray } from '../../../web/styles/colors';
import { background, borderColor, brandPrimary, titles } from '../../styles/colors';

export const styleSheet = StyleSheet.create({
	container: {
		boxSizing: 'border-box',
		height: '100%',
		display: 'flex',
		flexDirection: 'column',
		paddingBottom: 8,
		position: 'relative',
	},
	header: {
		borderBottom: `1px solid ${aceGray}`,
		padding: '16px 24px',
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'space-between',
		gap: 8,
	},
	headerTitle: {
		fontSize: '1rem',
		lineHeight: '1.5rem',
		fontWeight: 'bold',
		color: brandPrimary,
	},
	content: {
		flex: 1,
		display: 'flex',
		flexDirection: 'column',
		padding: '24px',
		overflowY: 'auto',
		gap: 16,
	},
	loadingContainer: {
		flex: 1,
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
	},
	subtitle: {
		fontSize: '0.875rem',
		color: charmGray,
		marginBottom: 8,
	},
	field: {
		display: 'flex',
		flexDirection: 'column',
		gap: 8,
	},
	label: {
		fontSize: '0.875rem',
		fontWeight: 500,
		color: titles,
	},
	textarea: {
		minHeight: 96,
	},
	select: {
		width: '100%',
		boxSizing: 'border-box',
		backgroundColor: background,
		borderRadius: 8,
		outline: 'none',
		padding: '12px 16px',
		border: `1px solid ${borderColor}`,
		fontSize: '0.875rem',
		fontFamily: 'inherit',
		':focus': {
			borderColor: brandPrimary,
		},
	},
	buttonSection: {
		display: 'flex',
		alignItems: 'center',
		gap: 12,
		marginTop: 'auto',
		paddingTop: 16,
	},
});
